import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Layout from './layout/layout';
import LoginPage from './pages/authentication/login.page';
import OtpVerificationsPage from './pages/authentication/otp-verification.page';
import SignUpPage from './pages/authentication/sign-up/sign-up.page';
import DashboardPage from './pages/admin/dashboard.page';
import ClaimSubmissionPage from './pages/admin/claim-submission/claim-submission.page';
import UserSettingPage from './pages/admin/setting/user/user-setting.page';
import portalAPI from './api/api';
import { AUTH_CHECK_URL } from './api/URLs';
import UndefinedUserPage from './pages/authentication/undefined-user.page';
import ClaimsListPage from './pages/admin/claims-list/claims-list.page';
import ReimbursementMethodsPage from './pages/admin/reimbursement-methods/reimbursement-methods.page';
import LinkAccountPage from './pages/admin/reimbursement-methods/link-account.page';
import EditCheckPage from './pages/admin/reimbursement-methods/edit-check.page';
import SupportPage from './pages/admin/reimbursement-methods/support.page';
import TermOfUsePage from './pages/admin/term-of-use/term-of-use.page';


function App() {
  const user = useSelector((state) => state.authenticatedUser);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);

  useEffect(() => {
    if (!user) {
      setAuthenticated(false);
    } else {
      (async () => {
        try {
          await portalAPI.get(AUTH_CHECK_URL);
          setAuthenticated(true);
        } catch (e) {
          setAuthenticated(false);
        }
      })();
    }
  }, [user]);

  return (
    <>
      <Routes>
        {
          !authenticated && !user && (
            <Route>
              <Route path="/*" element={<Navigate to="/auth/login" />} />
              <Route path='/auth' element={<Layout />}>
                <Route path="login" element={<LoginPage />} />
                <Route path="verify-email" element={<OtpVerificationsPage />} />
                <Route path="sign-up" element={<SignUpPage />} />
                <Route path="undefined" element={<UndefinedUserPage />} />
              </Route>
            </Route>
          )
        }
        {
          authenticated && user && (
            <Route element={<Layout />}>
              <Route path="/*" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/claims-list" element={<ClaimsListPage />} />
              <Route path="/claims-processing">
                <Route path="submission" element={<ClaimSubmissionPage />} />
                <Route path="resubmit/:caseNumber" element={<ClaimSubmissionPage />} />
              </Route>
              <Route path="user-details" element={<UserSettingPage />} />
              <Route path="/setting">
                <Route path="reimbursement-methods" element={<ReimbursementMethodsPage />} />
                <Route path="reimbursement-methods/edit-check" element={<EditCheckPage />} />
                <Route path="reimbursement-methods/link-account" element={<LinkAccountPage />} />
              </Route>
            </Route>
          )
        }
        <Route element={<Layout />}>
          <Route path="contact-us" element={<SupportPage />} />
          <Route path="term-of-use" element={<TermOfUsePage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
